"use client";
import { useModalBaseContext } from "./ModalBase.context.mjs";
//#region packages/@mantine/core/src/components/ModalBase/use-modal-transition.ts
const DEFAULT_TRANSITION = {
	duration: 200,
	timingFunction: "ease",
	transition: "fade"
};
function useModalTransition(transitionOverride) {
	const ctx = useModalBaseContext();
	return {
		...DEFAULT_TRANSITION,
		...ctx.transitionProps,
		...transitionOverride
	};
}
//#endregion
export { useModalTransition };

//# sourceMappingURL=use-modal-transition.mjs.map